/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RecipientDoctorList.vue?vue&type=template&id=bcb24f82&scoped=true"
import script from "./RecipientDoctorList.vue?vue&type=script&lang=js"
export * from "./RecipientDoctorList.vue?vue&type=script&lang=js"
import style0 from "./RecipientDoctorList.vue?vue&type=style&index=0&id=bcb24f82&lang=scss&scoped=true"
import style1 from "./RecipientDoctorList.vue?vue&type=style&index=1&id=bcb24f82&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb24f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcb24f82')) {
      api.createRecord('bcb24f82', component.options)
    } else {
      api.reload('bcb24f82', component.options)
    }
    module.hot.accept("./RecipientDoctorList.vue?vue&type=template&id=bcb24f82&scoped=true", function () {
      api.rerender('bcb24f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/RecipientDoctorList.vue"
export default component.exports